<div class="user-activity-summary" data-testid="user-activity-summary">
  <app-dp-detail-info>
    <!-- Error State -->
    <div
      *ngIf="error && !loading && !isProcessing"
      class="alert alert-danger mb-3"
      role="alert"
    >
      {{ error }}
    </div>

    <!-- Activity Summary Container -->
    <div class="activity-summary-container">
      <div class="d-flex flex-wrap align-items-end mb-2">
        <!-- Date Range Controls -->
        <div class="search-item-date">
          <div class="input-group input-calendar-condition">
            <input
              #startDatePicker="bsDatepicker"
              [bsConfig]="bsConfig"
              [formControl]="startDate"
              [minDate]="minSelectableDate"
              [maxDate]="endDate.value"
              [readOnly]="true"
              bsDatepicker
              class="form-control wd-100px"
              data-testid="date-range-start"
              placement="bottom"
              type="text"
            />
            <span class="input-group-text bg-transparent">
              <img
                (click)="startDatePicker.toggle()"
                [attr.aria-expanded]="startDatePicker.isOpen"
                class="duration-icon"
                src="assets/img/ico-duration.svg"
                alt="Calendar"
              />
            </span>
          </div>
        </div>
        <div class="search-item-date">
          <div class="input-group input-calendar-condition">
            <input
              #endDatePicker="bsDatepicker"
              [bsConfig]="bsConfig"
              [formControl]="endDate"
              [minDate]="minEndDate"
              [maxDate]="today"
              [readOnly]="true"
              bsDatepicker
              class="form-control wd-100px"
              data-testid="date-range-end"
              placement="bottom"
              type="text"
            />
            <span class="input-group-text bg-transparent">
              <img
                (click)="endDatePicker.toggle()"
                [attr.aria-expanded]="endDatePicker.isOpen"
                class="duration-icon"
                src="assets/img/ico-duration.svg"
                alt="Calendar"
              />
            </span>
          </div>
        </div>
        <div class="ms-2" style="margin-bottom: 13px" *ngIf="isDealer && isHq">
          <div class="btn-group view-toggle-group" role="group">
            <button
              class="btn btn-sm"
              [ngClass]="{
                'btn-primary': isHQView,
                'btn-outline-primary': !isHQView
              }"
              type="button"
              (click)="toggleHQView()"
            >
              HQ
            </button>
            <button
              class="btn btn-sm"
              [ngClass]="{
                'btn-primary': !isHQView,
                'btn-outline-primary': isHQView
              }"
              type="button"
              (click)="toggleHQView()"
            >
              ALL
            </button>
          </div>
        </div>
        <!-- Export Button -->
        <div class="ms-auto" style="margin-bottom: 13px">
          <div class="position-relative">
            <button
              (click)="onExport()"
              [disabled]="loading || isProcessing"
              class="btn btn-primary btn-sm"
              data-testid="export-activity"
              type="submit"
            >
              Export
            </button>
          </div>
        </div>
      </div>
      <!-- Loading State -->
      <div *ngIf="loading || isProcessing" class="loading-state">
        <div class="row">
          <div
            *ngFor="let i of [1, 2, 3, 4, 5]"
            class="col-12 col-md-6 col-lg-4 mb-3"
          >
            <div class="activity-card skeleton-card">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- KPI Cards (데이터가 0이어도 표시) -->
      <div
        *ngIf="!loading && !isProcessing && data !== null"
        class="activity-cards"
      >
        <div class="row">
          <!-- Login Activity -->
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div class="activity-card" data-testid="card-login">
              <h6 class="card-title">{{ getCardTitle("login") }}</h6>
              <div class="card-content">
                <div class="kpi-item">
                  <span class="kpi-label">Login Frequency</span>
                  <span class="kpi-value">{{
                    getCardData("login")?.frequency || 0 | number
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tickets Created -->
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div
              (click)="onCardClick('created')"
              class="activity-card activity-card-clickable"
              data-testid="card-created"
              role="button"
              tabindex="0"
              (keydown.enter)="onCardClick('created')"
            >
              <h6 class="card-title card-title-with-detail">
                <span>{{ getCardTitle("created") }}</span>
                <span class="kpi-detail">Detail</span>
              </h6>
              <div class="card-content">
                <div class="kpi-item">
                  <span class="kpi-label">Tickets Created</span>
                  <span class="kpi-value">{{
                    getTicketCreatedCount() | number
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tickets Canceled -->
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div class="activity-card" data-testid="card-canceled">
              <h6 class="card-title">{{ getCardTitle("canceled") }}</h6>
              <div class="card-content">
                <div class="kpi-item">
                  <span class="kpi-label">Tickets Canceled</span>
                  <span class="kpi-value">{{
                    getCardData("canceled")?.count || 0 | number
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tickets Viewed -->
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div class="activity-card" data-testid="card-viewed">
              <h6 class="card-title">{{ getCardTitle("viewed") }}</h6>
              <div class="card-content">
                <div class="kpi-item">
                  <span class="kpi-label">Tickets Viewed</span>
                  <span class="kpi-value">{{
                    getCardData("viewed")?.count || 0 | number
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tickets Edited -->
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div class="activity-card" data-testid="card-edited">
              <h6 class="card-title">{{ getCardTitle("edited") }}</h6>
              <div class="card-content">
                <div class="kpi-item">
                  <span class="kpi-label">Tickets Edited</span>
                  <span class="kpi-value">{{
                    getCardData("edited")?.count || 0 | number
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Training video viewed -->
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div
              (click)="onCardClick('training')"
              class="activity-card activity-card-clickable"
              data-testid="card-created"
              role="button"
              tabindex="0"
              (keydown.enter)="onCardClick('training')"
            >
              <h6 class="card-title card-title-with-detail">
                <span>{{ getCardTitle("video") }}</span>
                <span class="kpi-detail">Detail</span>
              </h6>
              <div class="card-content">
                <div class="kpi-item">
                  <span class="kpi-label">Video Viewed</span>
                  <span class="kpi-value">{{
                      getVideoViewCount() | number
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-dp-detail-info>
</div>
